import type { FilterGroup } from '@features/ui-filters/components/types';

export type SortDirection = 'ASC' | 'DESC';

export interface MylowQueryObject {
  page?: number;
  pageSize?: number;
  sorted?: Array<{ id: string; desc: SortDirection }>;
  filtered?: Array<{
    id: string;
    value: unknown;
  }>;
  withInfo?: boolean;
  debug?: boolean;
  includePocStats?: boolean;
  pocPreviewLimit?: number;
  memberContext?: string;
  // Comma-separated list-item expansions (e.g. 'spaceObject' on /ssts);
  // only accepted by the backend with pageSize <= 100
  expand?: string;
}

export function convertFiltersToApiParams(
  filters: FilterGroup,
  options: {
    removeEmptyValues?: boolean;
    emptyValues?: (string | null | undefined)[];
    page?: number;
    pageSize?: number;
    sorted?: Array<{ id: string; desc: SortDirection }>;
    includePocStats?: boolean;
    pocPreviewLimit?: number;
    memberContext?: string;
    expand?: string;
  } = {},
): MylowQueryObject {
  const {
    removeEmptyValues = true,
    emptyValues = ['all', '', undefined, null],
    page,
    pageSize,
    sorted,
    includePocStats,
    pocPreviewLimit,
    memberContext,
    expand,
  } = options;

  const queryObject: MylowQueryObject = {
    page,
    pageSize,
    sorted,
    includePocStats,
    pocPreviewLimit,
    memberContext,
    expand,
    filtered: [],
  };

  Object.entries(filters).forEach(([key, value]) => {
    if (removeEmptyValues) {
      if (Array.isArray(value)) {
        if (value.every(v => emptyValues.includes(v))) {
          return;
        }
      } else if (emptyValues.includes(value as string | null | undefined) && typeof value !== 'boolean') {
        return;
      }
    }

    queryObject.filtered!.push({
      id: key,
      value,
    });
  });

  return queryObject;
}
